import { React,useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { CATEGORIES } from '../../../data/Categories';
import { HomeIcon, Squares2X2Icon } from '@heroicons/react/20/solid';
import { ChevronRightIcon } from '@heroicons/react/24/solid';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Collection({ handleClick, products }) {
    const {category} = useParams(); 
    const [ items, setItems] = useState([]);

    const categoryItem = CATEGORIES.find(cat => cat.slug === category)

    useEffect(() => {
        const getItems = async () => {
            const categoryItems = products.filter(item => item.category === category);
            setItems(categoryItems)
        }
        getItems()
    }, [category])

  return (
    <div className="bg-white pt-4">
      <div>
        <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
          <div className="flex items-baseline justify-between border-b  pb-6 pt-24">
            {/* <h1 className="text-2xl lg:text-4xl font-medium tracking-tight text-gray-900">Nouvelle Collection</h1> */}


        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li className="inline-flex items-center">
              <Link to={`/`} className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 " >
                  <HomeIcon className='w-3,5 h-3.5'/>
              </Link>
              </li>
              <li aria-current="page">
              <div className="flex items-center">
                  <ChevronRightIcon className=' rtl:rotate-180 w-3.5 h-3.5 font-bold text-gray-700 mx-1' />
                  <span className="ms-1 text-sm font-medium text-gray-500 md:ms-2">{categoryItem.name}</span>
              </div>
              </li>
          </ol>
        </nav>


    <div className="flex items-center">
        <Link to={`/new-collection`} className='text-sm font-medium' >
            Voir tous
        </Link>
        <button type="button" className="-m-2 ml-5 p-2 text-gray-400 cursor-text sm:ml-7">
            <span className="sr-only">View grid</span>
            <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
        </button>
        
        </div>
      </div>
          <div className="grid grid-cols-2 py-6 pb-16 gap-x-6 gap-y-10 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 xl:gap-x-8">
                {items.map((product) => (
                    <div data-aos="zoom-in">
                      <Link to={`/product/${product.id}`} className="group" >
                        <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                          <img
                            src={product.image}
                            alt={product.slug}
                            className="h-full w-full object-cover object-center group-hover:opacity-75"
                          />
                        </div>
                        <div className='flex justify-between items-end'>
                          <h3 className="mt-4 text-sm text-gray-900">{product.name}</h3>
                          <p className="mt-1 text-lg font-medium text-gray-900">{product.price}$</p>
                        </div>
                      </Link>
                      <button onClick={() => handleClick(product)} className='flex justify-center w-full text-sm font-medium text-gray-900 bg-gray-100 py-2 rounded-lg mt-3 focus:ring-1 focus:ring-black focus:ring-offset-2'>Ajouter au panier</button>
                    </div>
                 ))}
            </div>
        </main>
      </div>
    </div>
  )
}
